import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteCallRecordingApi = (data, callback, errorCallBack) => { 
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.VIDEO.DELETE_CALL_RECORDING,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteCallRecordingApi
